import { useState } from 'react';
import { Alert, Button, Modal, ModalActions, TextArea } from '@evogard/ui';

/**
 * O pedido de motivo — reabrir uma competência e invalidar um vínculo. Os dois
 * mudam dinheiro de alguém, e o motivo vai para o log.
 */
export function ReasonDialog({
  title,
  descricao,
  confirm,
  pending,
  error,
  onConfirm,
  onClose,
}: {
  title: string;
  descricao: string;
  confirm: string;
  pending: boolean;
  error: string | null;
  onConfirm: (reason: string) => void;
  onClose: () => void;
}) {
  const [reason, setReason] = useState('');
  const short = reason.trim().length < 3;
  return (
    <Modal open onOpenChange={(o) => !o && onClose()} title={title} descricao={descricao}>
      <form
        className="flex flex-col gap-4"
        onSubmit={(e) => {
          e.preventDefault();
          if (!short) onConfirm(reason.trim());
        }}
      >
        <TextArea
          label="Motivo"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          help="Fica no log da premiação, com o seu nome."
          rows={3}
        />
        {error && <Alert tone="erro">{error}</Alert>}
        <ModalActions>
          <Button type="button" variant="contorno" onClick={onClose}>
            Voltar
          </Button>
          <Button type="submit" loading={pending} disabled={short}>
            {confirm}
          </Button>
        </ModalActions>
      </form>
    </Modal>
  );
}
